import { NATIONALITY_HISTORY } from 'constant/NationalityTerms';
import TermsFrame from './TermsFrame';

const NationalityTerms = () => {
  return (
    <TermsFrame
      title="(선택) 국적 정보 수집 및 이용에 대한 선택 동의"
      url="nationality-terms"
      historyData={NATIONALITY_HISTORY}
    />
  );
};

export default NationalityTerms;
